import React, { useEffect } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

import '@fontsource/roboto/100.css';
import '@fontsource/roboto/100-italic.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/300-italic.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/500-italic.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/700-italic.css';
import '@fontsource/roboto/900.css';
import '@fontsource/roboto/900-italic.css';
import '@fontsource/tasa-orbiter/400.css';
import '@fontsource/tasa-orbiter/500.css';
import '@fontsource/tasa-orbiter/600.css';
import '@fontsource/tasa-orbiter/700.css';
import '@fontsource/tasa-orbiter/800.css';
import 'material-icons/iconfont/filled.css';
import '../index.css';
import '../styles/backup-zeroheight.css';
import '../node_modules/@digital-engineering-experiences/wb-webcomponents/dist/style.css';

function MyApp({
    Component,
    pageProps,
}: {
    Component: React.ComponentType<any>;
    pageProps: any;
}) {
    useEffect(() => {
        const connectionString =
            process.env.NEXT_PUBLIC_APPLICATIONINSIGHTS_CONNECTION_STRING;
        if (!connectionString || connectionString == '') return;

        const reactPlugin = new ReactPlugin();
        const appInsights = new ApplicationInsights({
            config: {
                disableCookiesUsage: true,
                disablePageUnloadEvents: ['unload'],
                connectionString: connectionString,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: {},
                },
            },
        });
        appInsights.loadAppInsights();
        appInsights.trackPageView();
    }, []);

    return <Component {...pageProps} />;
}

export default MyApp;
